import React, { Component } from 'react';
import './index.css';



class NavItemLeft extends Component {
  constructor(props) {
    super(props);
    this.state = {
    }
    this.clickHandler = this.clickHandler.bind(this);
  }

  clickHandler(e,key){
    this.props.onClick(e,key);
  }

  render() {
    const { lang } = this.props;
    return (
      <div onClick={(e)=>this.clickHandler(e,'prev')} className="blog-sbc-header-nav-item-left">
        <button> 
          <div></div>
          <span style={{width: "80px"}}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 97.17 14.92">
              <switch>
                <g>
                  <path d="M97.17 7.46L89.71 0v6.52H0V8.4h89.71v6.52z" strokeWidth="0"></path>
                </g>
              </switch>
            </svg>
          </span>
          {lang==='fa'? 'قبلی' : 'Prev'}
        </button>
      </div>
    );
  }
}



export default NavItemLeft;
